import { useState } from "react";
import { ManagementType } from "types/common";
import { USER_GROUPS } from "constants/roles";
import { icons } from "constants/icons";
import { AuthStatusModal } from "components/Modal/AuthStatusModal";
import { selectCurrentClinicianLoading } from "store/ClinicianStore/selectors";
import { useAppSelector } from "hooks/reduxHooks";
import { getClinicPatientsList } from "store/PatientStore/actions";
import { getCliniciansList } from "store/ClinicianStore/actions";
type HeaderModalsByTabProps = {
  managementType?: ManagementType;
  setOpenFilterModal: any;
  currentClinician: any;
  setOpenInviteFilterModal: any;
  openInviteFilterModal: any;
};

const HeaderModalsByTab = ({
  managementType,
  setOpenFilterModal,
  currentClinician,
  setOpenInviteFilterModal,
  openInviteFilterModal,
}: HeaderModalsByTabProps) => {
  const [openUserFilterModal, setOpenUserFilterModal] =
    useState<boolean>(false);
  const currentClinicianLoading = useAppSelector(selectCurrentClinicianLoading);

  return (
    <>
      {managementType === ManagementType.USER && (
        <>
          <img
            src={icons.filterDetail}
            style={{ cursor: "pointer" }}
            alt="filterDetail"
            onClick={() => {
              setOpenUserFilterModal(true);
            }}
            aria-hidden="true"
          />

          <AuthStatusModal
            isEnabled={openUserFilterModal}
            setIsEnabled={setOpenUserFilterModal}
            loading={false}
            getList={getCliniciansList}
            roleFilters
          />
        </>
      )}
      {managementType === ManagementType.PATIENT_CARE && (
        <img
          src={icons.filterDetail}
          style={{ cursor: "pointer" }}
          alt="filterDetail"
          onClick={() => {
            setOpenFilterModal(true);
          }}
          aria-hidden="true"
        />
      )}

      {managementType === ManagementType.PATIENT &&
        currentClinician?.role?.includes(USER_GROUPS.CLINIC_ASSISTANT) && (
          <>
            <img
              aria-hidden="true"
              src={icons.filterDetail}
              style={{ cursor: "pointer" }}
              alt="filterDetail"
              onClick={() => {
                setOpenInviteFilterModal(true);
              }}
            />
            <AuthStatusModal
              isEnabled={openInviteFilterModal}
              setIsEnabled={setOpenInviteFilterModal}
              loading={currentClinicianLoading}
              getList={getClinicPatientsList}
            />
          </>
        )}
    </>
  );
};

export default HeaderModalsByTab;
